import { Cip } from './../../../models/cip.model';
import { Component } from "@angular/core";
import * as moment from 'moment'
import { FormControl, FormGroup, Validators} from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';



@Component({
    selector: "page-cip",
    templateUrl: "./cip.component.html", 
    providers: [FormService]
})

export class CipComponent {
    
    public rows = [];
      public actualRow;
      public cip: Cip;
      public form;
      public fecha_cip;
      public maxDate;
      
      matcher = new FormService();
      

    constructor( public _formService: FormService){
        this.maxDate = moment().toDate()
        this.form = new FormGroup({
            certcip: new FormControl('', Validators.required),
            fecha_cip:new FormControl({value: '', disabled:true}, Validators.required)
        })

        if(!JSON.parse(localStorage.getItem("cip"))){
            localStorage.setItem("cip", JSON.stringify(this.rows));
        }else{
            
            this.rows = JSON.parse(localStorage.getItem("cip"));

            //this.form.controls['fecha_cip'].setValue(this.rows[0] ? new Date(moment(this.rows[0].fecha_cip, "DD/MM/YYYY").toDate()) : null)
            this.form.controls['fecha_cip'].setValue(this.rows[0] ? moment(this.rows[0].fecha_cip, "DD/MM/YYYY").toDate() : null)
            this.form.controls['certcip'].setValue(this.rows[0]?this.rows[0].certcip:'')
            
            
        }

        
        

    }


    add_cip( event?: MatDatepickerInputEvent<Date>, type?){

        if(event){

             this.fecha_cip = moment(event.value).format('DD/MM/YYYY')
        } else {
            var temp = JSON.parse(localStorage.getItem("cip"))
            if(temp[0]){
                this.fecha_cip = temp[0].fecha_cip
            }else {
                this.fecha_cip = ''
            }
            
        }
        localStorage.setItem("cip",JSON.stringify([]));
        this.actualRow = localStorage.getItem("cip");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            certcip: this.form.value.certcip,
            fecha_cip: this.fecha_cip
        })

        localStorage.setItem("cip", JSON.stringify(this.rows));
        //this.form.reset();
        //this.cip = JSON.parse(localStorage.getItem("cip"));

    }
    
    delete_cip(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("cip", JSON.stringify(this.rows));
            }
        }
    }
}